import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import Header from '../components/Header'

import 'polythene-css/dist/polythene.css' // Component CSS
import 'polythene-css/dist/polythene-typography.css' // Default Material Design styles including Roboto font
import './index.css'
import './unsemantic.css'

import { flex } from 'polythene-core-css'

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet title="SubFire Suite Home" />
    <Header />
    <div className="grid-container">{children()}</div>
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js